import { RN_AI_AUDIO_S3_BUCKET } from "./rn-ai-agent-constants";

export function normalizeRnAiAudioPath(audioPath: string): string {
    return audioPath.replace(/^\/+/, "");
}

/** S3 object keys to try (API paths are often without the bucket folder prefix). */
export function rnAiAudioS3KeyCandidates(audioPath: string): string[] {
    const key = normalizeRnAiAudioPath(audioPath);
    if (!key) return [];

    const prefix = `${RN_AI_AUDIO_S3_BUCKET}/`;
    const candidates = [key];
    if (!key.startsWith(prefix)) {
        candidates.push(`${prefix}${key}`);
    }
    return [...new Set(candidates)];
}

export function rnAiMediaUrl(path?: string): string | null {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    return `https://www.rajneethi.com/${normalizeRnAiAudioPath(path)}`;
}
